import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

export type TUpdateBudgetDocumentById = {
    documentId: string;
    params: {
        document_title: string;
        enterprise: string;
        project: string;
    };
};

export type TUpdateDocumentByIdResponse = {
    data: any;
};

export default async ({ documentId, params }: TUpdateBudgetDocumentById) => {
    const httpResponse = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/budget/document/${documentId}`,
        method: "put",
        headers: { auth: true },
        body: params,
    });
    const { body, statusCode } = httpResponse;

    return handleStatusCases<TUpdateDocumentByIdResponse>({
        body,
        statusCode,
    });
};
